import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React, { useState } from 'react';
import { PlaylistLesson, PlaylistModule } from '@/store/playlist/types';
import { TemplateDarkMembersFooter } from './TemplateDarkMembersFooter';
import { ChevronLeft } from 'lucide-react';
import logoHostVslWhite from '@/assets/logo-hostvsl-white.png';

interface DarkMembersLessonPageProps {
  lesson: PlaylistLesson;
  module: PlaylistModule;
  onBack: () => void;
}

export function DarkMembersLessonPage({ 
  lesson, 
  module, 
  onBack 
}: DarkMembersLessonPageProps) {
  useLanguage();
  return (
    <div data-theme-isolated className="min-h-screen bg-[#0E0E0E] flex flex-col">
      {/* Header */}
      <header className="h-16 bg-[#0057FF] sticky top-0 z-50 px-4 md:px-8 flex items-center gap-4">
        <button 
          onClick={onBack}
          className="text-white hover:text-white/80 transition-colors flex items-center gap-2"
        >
          <ChevronLeft className="w-5 h-5" />
          <span className="text-sm">{translateInterfaceText("Voltar")}</span>
        </button>
        <img src={logoHostVslWhite} alt={translateInterfaceText("HostVSL")} className="h-6 ml-auto" />
      </header>

      {/* Player HostVSL */}
      <section className="py-8 px-4 flex-1">
        <div className="max-w-[1100px] mx-auto">
          {/* Video Player */}
          <div className="aspect-video bg-black rounded-xl overflow-hidden mb-6">
            <video 
              className="w-full h-full object-contain"
              controls
              autoPlay
              playsInline
              src={`https://example.com/videos/${lesson.videoId}.mp4`}
            >
              {translateInterfaceText("Seu navegador não suporta vídeos.")}</video>
          </div>

          {/* Título da Aula */}
          <h1 className="text-white text-xl md:text-2xl font-bold">
            {lesson.title}
          </h1>

          {/* Info do Módulo */}
          <p className="text-gray-400 text-sm mt-2">
            {module.title}
          </p>

          {/* Descrição */}
          {lesson.description && (
            <div className="mt-6">
              <h2 className="text-white text-lg font-semibold mb-2">
                {translateInterfaceText("Sobre esta aula")}</h2>
              <p className="text-gray-400 text-sm leading-relaxed whitespace-pre-wrap">
                {lesson.description}
              </p>
            </div>
          )}
        </div>
      </section>

      <TemplateDarkMembersFooter 
        showTerms={true}
        showPrivacy={true}
      />
    </div>
  );
}
